import toastMessage from "../toastMessage";
import formatSelectData from "../formatSelectData";
import { getStorage } from "../storage";
import language from "../../language";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const fetchData = async (lng = "english", { page, limit, type, category }) => {
  try {
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${API_URL}/serviceCategory`,
      params: {
        page: page,
        limit: limit,
        type: category,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      return formatSelectData(queryRes.data, "name", "_id");
    }

    return { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", language[lng].unable_fetch_service_category);
  }
};

export const deleteServiceCategory = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/serviceCategory`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_service_category);
  } catch (error) {
    toastMessage("error", language[lng].error_delete_service_category);
  }
};

export default fetchData;
